import { styled, SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  color?: 'default' | 'warning' | 'success' | 'primary';
  marginBottom?: number;
  alignItems?: string;
  sx?: SxProps;
}

const Header = styled('div', {
  shouldForwardProp: (prop) => prop !== 'marginBottom' && prop !== 'alignItems',
})<Props>(({ theme, marginBottom = 0, alignItems }) => ({
  display: 'grid',
  width: '100%',
  alignItems,
  gridTemplateColumns: `${theme.spacing(2)} 1fr auto`,
  gridGap: theme.spacing(2),
  marginBottom: theme.spacing(marginBottom),
}));

const Tag = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<Pick<Props, 'color'>>(({ theme, color }) => {
  const palette = (theme.vars || theme).palette;
  return {
    width: theme.spacing(2),
    height: theme.spacing(4),
    background:
      color === 'warning'
        ? palette.gradient.warning
        : color === 'success'
        ? palette.success.main
        : color === 'primary'
        ? palette.primary.main
        : palette.secondary.main,
    borderRadius: Number(theme.shape.borderRadius),
  };
});

export default function TagHeading({
  color = 'default',
  marginBottom = 0,
  children,
  alignItems = 'center',
  sx,
}: PropsWithChildren<Props>) {
  return (
    <Header marginBottom={marginBottom} alignItems={alignItems} sx={sx}>
      <Tag color={color} />
      {children}
    </Header>
  );
}
